<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />
    <div class="save-panel">
      <button class="btn  btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>{{ 'save' | setText('Сохранить') }}
      </button>
    </div>
  </div>
</template>
<script>
import { cardUpdate, cardContent } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "divisions",
    item: null,
    fields: [
    ],
  }),
  props: ["id"],
  async created() {
    this.fields = [
      {
        label: "Предмет",
        key: "discipline",
        type: "select",
        selectKey: "title",
        modal: "business_discipline",
        prefix: "lessonplan_discipline",
        params: {}
      },
      {
        col: 'col-12 col-md-12',
        label: "Ученики",
        key: "clients",
        type: "clients",
        group_id: this.group_id
      }
    ];
    this.cardLink = `business/groups/${this.group_id}/divisions`;
    this.item = await this.cardContent(this.cardLink, this.division_id);
  },
  computed: {
    group_id() {
      return this.id.split("-")[1];
    },
    division_id() {
      return this.id.split("-")[0];
    },
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,

    async updateItem() {
      let item = await this.cardUpdate(this.cardLink, this.item, this.fields);

    },
  },
};
</script>
<style>
</style>
